/**
 * Widget catalog — maps GridItem.contentType → React component.
 *
 * Add new widgets here as one-line catalog entries.
 */
import { SectionWidget } from "./SectionWidget.js";
import { InlineWidget } from "./InlineWidget.js";
import { TextEditorWidget } from "./TextEditorWidget.js";
import { ImageWidget } from "./ImageWidget.js";
import { VideoWidget } from "./VideoWidget.js";
import { AudioWidget } from "./AudioWidget.js";
import { FormWidget } from "./FormWidget.js";
import { NavWidget } from "./NavWidget.js";
import { SpacerWidget } from "./SpacerWidget.js";
import { registeredWidget } from "./catalogRegistry.js";
import type { WidgetCatalog, WidgetComponent } from "./types.js";

export const catalog: WidgetCatalog = {
  // A top-level "grid" item is a section block — SectionWidget wraps the
  // nested grid (GridWidget) with header/handle/delete chrome.
  grid: SectionWidget,
  // An Inline is a one-row nested grid inside a section (blocks drop in).
  "inline-grid": InlineWidget,
  text: TextEditorWidget, // T3.12: full lexical-multi editor
  image: ImageWidget, // T3.11: presigned PUT upload
  video: VideoWidget, // content-addressed video (same asset pipeline as image)
  audio: AudioWidget, // content-addressed audio with a waveform player (web-only)
  form: FormWidget, // T3.13: contact form
  nav: NavWidget, // shared header/footer page-links menu (locked)
  spacer: SpacerWidget, // pure layout whitespace (grid cell = its size)
};

/** Resolve a widget for a contentType — an app-registered renderer (the
 *  injection seam) wins over the built-in catalog. */
export function resolveWidget(
  contentType: string,
): WidgetComponent | undefined {
  return registeredWidget(contentType) ?? catalog[contentType];
}

export { registerWidget } from "./catalogRegistry.js";
export type { WidgetProps, WidgetCatalog } from "./types.js";
